var render = function render(){var _vm=this,_c=_vm._self._c;return _c('loader',{attrs:{"loading":!_vm.loaded}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }